import React from 'react';

import Markup from '../../markup';

function CheckBox({ active, disabled, onClick = () => {}, small, medium }: { active?: boolean, onClick?: Function, small?: boolean, medium?: boolean, disabled?: boolean }) {
  return (
    <>
      <Markup.Global.CheckBox.Item medium={medium} small={small} active={active} disabled={disabled} onClick={() => disabled ? undefined : onClick()} />
    </>
  );
}

export default React.memo(CheckBox);

